import React, { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

const ThemeToggle = () => {
    const [dark, setDark] = useState(() =>
        typeof document !== "undefined" && document.documentElement.classList.contains("dark")
    );

    useEffect(() => {
        const saved = localStorage.getItem("cherish_theme");
        if (saved === "dark") {
            document.documentElement.classList.add("dark");
            setDark(true);
        }
    }, []);

    const toggle = () => {
        const next = !dark;
        setDark(next);
        if (next) {
            document.documentElement.classList.add("dark");
            localStorage.setItem("cherish_theme", "dark");
        } else {
            document.documentElement.classList.remove("dark");
            localStorage.setItem("cherish_theme", "light");
        }
    };

    return (
        <button
            data-testid="theme-toggle"
            onClick={toggle}
            className="w-9 h-9 rounded-full flex items-center justify-center glass hover:scale-105 transition-transform"
            aria-label="Toggle theme"
        >
            {dark ? <Sun className="w-4 h-4 text-brand-gold" /> : <Moon className="w-4 h-4 text-primary" />}
        </button>
    );
};

export default ThemeToggle;
